/**
 * Zaehlt diese Nachricht fuer Abzeichen und Banner?
 *
 * Die Wahrheit steht im Server (`attentionUnreadIds` in partner-messages.ts)
 * und kommt pro Nachricht als `needsAttention` mit. Fehlt das Feld, redet
 * dieser Client mit einem aelteren Server — Dev-CUI und Partner-Server werden
 * getrennt gebaut, der Dev-Bundle alle 5 min (cui-auto-pull), der Partner
 * nachts (cui-rebuild). Ohne diesen Zweig zaehlte ein neuer Client an einem
 * alten Server ueberall 0 und meldete eine Entwarnung, die niemand geprueft
 * hat. Der alte Ausdruck lebt deshalb genau hier weiter, an einer Stelle,
 * und verschwindet, sobald beide Seiten neu sind.
 */
export function countsForAttention(
  m: { needsAttention?: boolean; readAt?: string | null; from?: string; status?: string; foldedInto?: string; category?: string },
  userId: string,
): boolean {
  if (m.needsAttention !== undefined) return m.needsAttention;
  return !m.foldedInto
    && m.readAt == null
    && m.from !== userId
    && (m.status ?? 'sent') === 'sent'
    && m.category !== 'monitoring';
}
